import React from 'react';
import { cn } from 'lib/utils';

export type SelectProps = React.SelectHTMLAttributes<HTMLSelectElement> & {
  className?: string;
  variant?: 'primary';
};

const Select = ({ className, variant = 'primary', ...props }: SelectProps) => {
  return (
    <select
      className={cn(
        'font-sans text-p2 rounded-lg py-2 pl-4 pr-10 focus:outline-2 focus:outline-offset-5 focus:outline-athletic-500',
        {
          // Variant: primary
          'bg-clay-50 text-graphite-900 appearance-none bg-select-field bg-no-repeat bg-position-[right_1rem_center] disabled:bg-neutral-300 disabled:cursor-not-allowed':
            variant === 'primary',
        },
        className
      )}
      {...props}
    />
  );
};

export default Select;
